import { AppTopBarList } from "@moment/design-system/AppTopBarList";

import { BackButton } from "~/components/topbar/BackButton";
import { TopBar } from "~/components/topbar/TopBar";

export const DocumentTopBar = () => {
	return (
		<TopBar>
			{/* left side */}
			<AppTopBarList>
				<BackButton />
			</AppTopBarList>
		</TopBar>
	);
};
